import { api } from '../api';

export const employeesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getEmployees: builder.query({
            query: ({ sortBy = 'rank:asc' } = {}) => ({
                url: `/employees?sort=${sortBy}&pagination[pageSize]=100&populate=*`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response,
        }),

    })
})

export const { useGetEmployeesQuery } = employeesApi;
